import React, { FC } from 'react'

import { IconMailReadProps } from './IconMailRead.types'
import * as Styled from './styles/IconMailRead.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMailRead: FC<IconMailReadProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMailReadProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconMailReadProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M158.83 72.17 91.3 4.65A15.9 15.9 0 0 0 80 0a15.89 15.89 0 0 0-11.3 4.7L1.17 72.17A4 4 0 0 0 0 75v69a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V75a4 4 0 0 0-1.17-2.83zM74.34 10.33a8 8 0 0 1 11.34 0l61.2 61.2-58.76 60.58a12.62 12.62 0 0 1-8.91 3.89 12.8 12.8 0 0 1-9-3.54l-.31-.31-56.82-60.57zM144 152H16a8 8 0 0 1-8-8V77.85l56 59.8.57.57a20.72 20.72 0 0 0 29.26-.55L152 77.75V144a8 8 0 0 1-8 8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMailRead
